import tw, { styled } from "twin.macro";

interface Props {
  semiBold?: boolean;
  medium?: boolean;
  big?: boolean;
}

const Header = styled.h1((props: Props) => {
  const { big, medium, semiBold } = props;

  return [
    tw`text-[2.4rem] font-bold`,
    big && tw`text-[3.2rem]`,
    medium && tw`text-[3rem]`,
    semiBold && tw`font-semibold`,
  ];
});

export default Header;
